'use client';

import { InverseHeader, RadialGradientBG } from '@jouzen/ecom-components';

import FooterMultivariatePaymentOptions from '@/app/components/MultivariatePaymentOptions/FooterMultivariatePaymentOptions';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import ActivityAndMovementFeatures from './_components/ActivityAndMovementFeatures';
import ActivityAndMovementFooter from './_components/ActivityAndMovementFooter';
import ActivityAndMovementHero from './_components/ActivityAndMovementHero';
import ActivityAndMovementIntegrations from './_components/ActivityAndMovementIntegrations';
import ActivityAndMovementJumbotron from './_components/ActivityAndMovementJumbotron';
import ActivityAndMovementTestimonials from './_components/ActivityAndMovementTestimonials';
import activityAndMovementPageGradients from './_data/activityAndMovementPageGradients';

const Content = () => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <section>
      <InverseHeader>
        <RadialGradientBG
          className="bg-cream-50"
          gradients={activityAndMovementPageGradients}
        >
          <ActivityAndMovementHero />
          <ActivityAndMovementFeatures />
          <ActivityAndMovementJumbotron />
          <ActivityAndMovementTestimonials />
          <ActivityAndMovementIntegrations />
        </RadialGradientBG>
        <ActivityAndMovementFooter />
        <FooterMultivariatePaymentOptions className="bg-[#E1BA8B] pb-16" />
      </InverseHeader>
    </section>
  );
};

export default Content;
